export default __webpack_public_path__ + "static/pnews_5-b1ee2e10c02a326e256eb211d8e6e045.png";